import React from 'react';
import { Link } from 'react-router-dom';
export function TopBar() {
  return <div className="w-full bg-[#1a0647] py-1.5 px-6 md:px-12" data-id="element-402" data-mp="232wzxtyst6xa">
      <div className="max-w-7xl mx-auto flex items-center justify-end" data-id="element-403" data-mp="231ls9j28ff0w">
        <span className="text-white text-xs font-normal" data-id="element-404" data-mp="1y4vdcz25yph2">
          Have you or a loved one been hacked? See our{' '}
          <Link to="/crisis-help" className="text-[#00f4f8] hover:underline" data-id="element-405" data-mp="1t6aeb2ynebu7">
            Crisis Response Guide
          </Link>
        </span>
      </div>
    </div>;
}